import { Comment, LinkPreview } from 'sparkello-core';

export class WebComment implements Comment {
  public id: string;
  public parentId: string;
  public text: string;
  public authorUid?: string;
  public authorName?: string;
  public authorProfileImage?: string;
  public linkPreviewId?: string;
  public linkPreview?: LinkPreview;
  public dateCreated?: Date;
  public lastUpdated?: Date;

  public constructor(id: string, parentId: string, text: string) {
    this.id = id;
    this.parentId = parentId;
    this.text = text;
  }

  public clone(): WebComment {
    return { ...this } as WebComment;
  }
}
